export const PR_MANAGERS_META_DESCRIPTION_BG =
  "Perceptica дава на PR мениджърите мониторинг в реално време, ранни сигнали и аналитични брифинги, за да реагират навреме и да комуникират с увереност.";
